import { render, staticRenderFns } from "./OpenPositions.vue?vue&type=template&id=1fb13b23&scoped=true&lang=pug&"
import script from "./OpenPositions.vue?vue&type=script&lang=js&"
export * from "./OpenPositions.vue?vue&type=script&lang=js&"
import style0 from "./OpenPositions.vue?vue&type=style&index=0&id=1fb13b23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb13b23",
  null
  
)

export default component.exports